import { FileCategory } from "./file-category";
import { FileStatus } from "./file-status";
import { ObjectType } from "./object-type";
import { ObjectLayer } from "./object-layer";
import { ObjectClass } from "./object-class";
import { ObjectStatus } from "./object-status";
import { immerable } from "immer";

export class DbWorkflowDefinitionInputFilterInfos {
  [immerable] = true;

  fileCategory: FileCategory | null = null;
  fileStatus: FileStatus | null = null;
  objectTypes: ObjectType[] | null = null;
  objectLayers: ObjectLayer[] | null = null;
  objectClasses: ObjectClass[] | null = null;
  objectStatuses: ObjectStatus[] | null = null;

  constructor(init?: Partial<DbWorkflowDefinitionInputFilterInfos>) {
    Object.assign(this, init);
  }
}
